<template>
    <button class="button-playAudio appearAnimationA" v-on:click="playAudioVoiced()"></button>
</template>

<script>
    export default {
        props: {
            audioRoute:{
                default:"none",
                type: String
            }
        },       
        methods: {
            playAudioVoiced(){
                var snd = new Audio(require(`../assets/audios/p51/${this.audioRoute}.mp3`));
                snd.play();
            }
        }
    }
</script>